import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconConnectionError, IconRecovery } from '../../../../../assets/icons';
import { useBackdropContext } from '../../../../../context/backdrop';
import { DeviceConnectionState } from '../../../../../data-access/gql-types/graphql';
import { toastError } from '../../../../../utils/toast';
import DeviceIcon from '../../../components/device-icon';
import { useDevicesAndChannels } from '../../../hooks/devices-and-channels';
import { useChannelsStateStore } from '../../../store/channels-state';
import { DeviceType } from '../../../types';
import { checkDeviceStatus } from '../../../utils/devices/status';

type DeviceInfoProps = {
  device: DeviceType;
};

const DeviceInfo: React.FC<DeviceInfoProps> = ({ device }) => {
  const { t } = useTranslation('device-settings');
  const { backdropOpen } = useBackdropContext();
  const { deviceChannels } = useDevicesAndChannels({ deviceId: device?.id });
  const channelState = useChannelsStateStore((s) => s.channelState);
  const isDeviceDisconnected = checkDeviceStatus(deviceChannels, channelState, DeviceConnectionState.Disconnected);
  const isDeviceInRecoveryState = checkDeviceStatus(deviceChannels, channelState, DeviceConnectionState.Recovery);

  useEffect(() => {
    if (isDeviceDisconnected && !device.isUpdating && !backdropOpen) {
      toastError({ content: t('connectionError.message'), icon: <IconConnectionError iconToastError size={16} /> });
    }
  }, [isDeviceDisconnected, device.isUpdating, backdropOpen]);

  useEffect(() => {
    if (isDeviceInRecoveryState) {
      toastError({ content: t('recoveryError.message'), icon: <IconRecovery iconToastError /> });
    }
  }, [isDeviceInRecoveryState]);

  if (!device?.payload.name) return null;

  return (
    <div className="driver-settings">
      <DeviceIcon model={device.payload.model} disconnected={isDeviceDisconnected} recovery={isDeviceDisconnected} />
      <h4 className="driver-settings__info">
        <div className="driver-title text-ellipsis">{device.payload.name || 'N/A'}</div>
        <div className="driver-type text-ellipsis">{device.payload.model}</div>
      </h4>
    </div>
  );
};

export default DeviceInfo;
